import { useContext } from "react";
import { Link } from "react-router-dom";

import Swal from "sweetalert2";

import TourCard from "./TourCard";

import { deleteTour as deleteTourService } from "../../services/adminTourList";
import Loader from "utilities/Loader";

export default function TourTab({
  tours,
  canNew = false,
  reservation = false,
  setLoading = () => {},
  getInfo,
}) {
  function deleteTour(id) {
    Swal.fire({
      title: "حذف",
      text: "آیا میخواهید این تور را حذف کنید؟",
      icon: "warning",
      showConfirmButton: true,
      confirmButtonColor: "#198754",
      confirmButtonText: "بله",
      showCancelButton: true,
      cancelButtonColor: "#dc3545",
      cancelButtonText: "خیر",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await deleteTourService(id);
        if (res) {
          Swal.fire({
            title: "تور با موفقیت حذف شد.",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          getInfo();
        } else {
          Swal.fire({
            title: "خطا!",
            text: "مشکلی پیش آمده، لطفا بعدا امتحان کنید.",
            showConfirmButton: true,
            icon: "error",
          });
        }
      }
    });
  }
  return (
    <>
      {/* filter and new */}
      <div className="d-flex m-4 flex-wrap justify-content-start">
        <div
          className="col-12 col-md-4 col-lg-6 "
          style={{ cursor: "pointer" }}
        >
          <div
            className=" m-1 txt fs-15 cursor-pointer border round p-2"
            data-bs-toggle="modal"
            data-bs-target="#filterModal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={16}
              height={16}
              fill="currentColor"
              className="bi bi-funnel"
              viewBox="0 0 16 16"
            >
              <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
            </svg>
            فیلتر
          </div>
        </div>
        {canNew ? (
          <Link
            to="/admin-panel/create-tour"
            className=" col-12 col-md-4 col-lg-6"
          >
            <span className=" text-decoration-none color-black ">
              <div
                className="m-1 border p-2 round txt"
                style={{ fontSize: "15px" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={16}
                  height={16}
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg>
                تور جدید
              </div>
            </span>
          </Link>
        ) : (
          ""
        )}
      </div>
      <div className="row the-tour-tab">
        {tours.map((value, index) => {
          let colorCount = reservation ? 3 : 4;
          let colorIndex = index % colorCount;
          let colors =
            colorIndex == 0
              ? ["orange", "cream"]
              : colorIndex == 1
              ? ["green", "pale-green"]
              : colorIndex == 2
              ? ["blue", "pale-blue"]
              : ["purple", "pale-purple"];
          return (
            <TourCard
              key={`tours-card-${index}`}
              tour={value}
              colors={colors}
              deleteTour={deleteTour}
              reservation={reservation}
              getInfo={getInfo}
              setLoading={setLoading}
            />
          );
        })}
      </div>
    </>
  );
}
